import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import ReactTimeAgo from 'react-time-ago';
import TimeAgo from 'javascript-time-ago';
import en from 'javascript-time-ago/locale/en';
import ru from 'javascript-time-ago/locale/ru';

TimeAgo.addDefaultLocale(en);
TimeAgo.addLocale(ru);

const TimeAgoView = ({ date }) => {
    const { i18n } = useTranslation();

    return (
        <Typography sx={{ color: 'var(--text-secondary)', fontSize: '0.875rem', whiteSpace: 'nowrap' }}>
            <ReactTimeAgo date={date} locale={i18n.language} />
        </Typography>
    );
};

export default TimeAgoView;
